var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_404",on:{"click":_vm.gotoHome}},[_c('img',{attrs:{"src":_vm.src,"alt":"404"}})])}
var staticRenderFns = []

export { render, staticRenderFns }